/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Segment
 */
export interface Segment {
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    officeKey: string;
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    lobKey: string;
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    portfolioId: string;
    /**
     * 
     * @type {SegmentStatusEnum}
     * @memberof Segment
     */
    status: SegmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Segment
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Segment
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Segment
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const SegmentStatusEnum = {
    Open: 'Open',
    InLocalReview: 'InLocalReview',
    InGlobalReview: 'InGlobalReview',
    Approved: 'Approved'
} as const;
export type SegmentStatusEnum = typeof SegmentStatusEnum[keyof typeof SegmentStatusEnum];


/**
 * Check if a given object implements the Segment interface.
 */
export function instanceOfSegment(value: object): value is Segment {
    if (!('officeKey' in value) || value['officeKey'] === undefined) return false;
    if (!('lobKey' in value) || value['lobKey'] === undefined) return false;
    if (!('portfolioId' in value) || value['portfolioId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SegmentFromJSON(json: any): Segment {
    return SegmentFromJSONTyped(json, false);
}

export function SegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Segment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'officeKey': json['officeKey'],
        'lobKey': json['lobKey'],
        'portfolioId': json['portfolioId'],
        'status': json['status'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function SegmentToJSON(json: any): Segment {
    return SegmentToJSONTyped(json, false);
}

export function SegmentToJSONTyped(value?: Segment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'officeKey': value['officeKey'],
        'lobKey': value['lobKey'],
        'portfolioId': value['portfolioId'],
        'status': value['status'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

